import { render, staticRenderFns } from "./tagEdit.vue?vue&type=template&id=02f63515&scoped=true"
import script from "./tagEdit.vue?vue&type=script&lang=js"
export * from "./tagEdit.vue?vue&type=script&lang=js"
import style0 from "./tagEdit.vue?vue&type=style&index=0&id=02f63515&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f63515",
  null
  
)

export default component.exports